// extracted by css-extract-rspack-plugin
export default {"details":"details-rUcvcx","detailsRow":"detailsRow-Vu2rrg","detailsRowIcon":"detailsRowIcon-ZCi1MA","detailsRowText":"detailsRowText-mtWky8"};